import { React, createContext} from 'react';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import { AppRouter } from './router/AppRouter';
import {AppProvider} from './context/app-context'
import { ConfigProvider, App as AntApp } from 'antd';
import { defaultTheme } from './style/themeConfig';
import './App.css';
import { NotificationProvider } from './components/UI/NotificationProvider';
import { MessageProvider } from './components/UI/MessageProvider';

Spin.setDefaultIndicator(<LoadingOutlined style={{ fontSize: 48, color: '#fff'}}/>)

function App() {
	return (
		<>
			<ConfigProvider theme={defaultTheme}>
				<AntApp>
					<NotificationProvider>
						<MessageProvider>
							<AppProvider>
								<AppRouter/>
							</AppProvider>
						</MessageProvider>
					</NotificationProvider>
				</AntApp>
			</ConfigProvider>
		</>
	);
}

export default App;